import { CheckoutState, setCoupon } from "modules/checkout";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useHistory } from "react-router";

export const useCheckout = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const checkoutState = useSelector(
    ({ checkout }: { checkout: CheckoutState }) => checkout
  );

  const removeCoupon = () => {
    dispatch(setCoupon(null));
    // Remove coupon from URL without refresh
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("coupon");
    history.replace({ search: searchParams.toString() });
  };

  return { ...checkoutState, removeCoupon };
};
